import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m5 5 6.232 1.484a1 1 0 0 1 .768.973v9.087a1 1 0 0 1-.768.972L5 19M9 11v2"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.539 4H6.461A2.46 2.46 0 0 0 4 6.462v11.077A2.46 2.46 0 0 0 6.462 20h11.077A2.46 2.46 0 0 0 20 17.538V6.462A2.46 2.46 0 0 0 17.538 4"
    }, null, -1)
  ])))
}
export default { render: render }